"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserGroup',
  data: function data() {
    return {
      visible: false,
      tableFrom: {
        page: 1,
        limit: 20
      },
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      labelPram: {
        value: '',
        id: ''
      },
      rules: {
        value: [{
          required: true,
          message: '请输入用户标签',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  watch: {
    '$route.path': function $routePath() {
      this.tableFrom.page = 1;
      this.getList();
    }
  },
  methods: {
    info: function info() {},
    onAdd: function onAdd(row) {
      if (row) {
        this.labelPram.id = row.id;
        this.labelPram.value = this.$route.path.indexOf('group') !== -1 ? row.groupName : row.name;
      } else {
        this.labelPram.id = '';
        this.labelPram.value = '';
      }
      this.visible = true;
    },
    confirm: function confirm() {
      var _this = this;
      if (this.$route.path.indexOf('group') !== -1) {
        this.labelPram.id ? (0, _user.groupUpdateApi)({
          id: this.labelPram.id
        }, {
          groupName: this.labelPram.value
        }).then(function () {
          _this.$message.success('编辑成功');
          _this.getList();
          _this.visible = false;
        }) : (0, _user.groupSaveApi)({
          groupName: this.labelPram.value
        }).then(function () {
          _this.$message.success('新增成功');
          _this.getList();
          _this.visible = false;
        });
      } else {
        this.labelPram.id ? (0, _user.tagUpdateApi)({
          id: this.labelPram.id
        }, {
          name: this.labelPram.value
        }).then(function () {
          _this.$message.success('编辑成功');
          _this.getList();
          _this.visible = false;
        }) : (0, _user.tagSaveApi)({
          name: this.labelPram.value
        }).then(function () {
          _this.$message.success('新增成功');
          _this.getList();
          _this.visible = false;
        });
      }
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      this.$route.path.indexOf('group') !== -1 ? (0, _user.groupListApi)(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      }) : (0, _user.tagListApi)(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this3 = this;
      this.$modalSure('删除吗？所有用户已经关联的数据都会清除').then(function () {
        _this3.$route.path.indexOf('group') !== -1 ? (0, _user.groupDeleteApi)({
          id: id
        }).then(function () {
          _this3.$message.success('删除成功');
          if (_this3.tableData.data.length === 1 && _this3.tableFrom.page > 1) _this3.tableFrom.page = _this3.tableFrom.page - 1;
          _this3.getList();
        }) : (0, _user.tagDeleteApi)({
          id: id
        }).then(function () {
          _this3.$message.success('删除成功');
          if (_this3.tableData.data.length === 1 && _this3.tableFrom.page > 1) _this3.tableFrom.page = _this3.tableFrom.page - 1;
          _this3.getList();
        });
      });
    }
  }
};